module.exports = __webpack_public_path__ + "img/sport1_hover.aa5a4a27.png";